import {
    SET_SELECTED_ACTIVITIES,
    SET_SELECTED_EXTRAS,
    SET_SELECTED_ROOMS,
    SET_TRIP_ID,
    SET_NOTES, SET_DEALER_CLIENT, SET_REFUNDABLE, SET_GUEST_INFO
} from "../constants/transactionConstants";

const defaultState = {
    tripId: 0,
    selectedRooms: [],
    extra: {},
    activities: {},
    notes: '',
	refundable: 0,
	guestInfo: {}
}

export const transactionReducer = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SELECTED_ROOMS:
            return {...state, selectedRooms: action.payload};
        case SET_SELECTED_EXTRAS:
            return {...state, extra: action.payload};
        case SET_SELECTED_ACTIVITIES:
            return {...state, activities: action.payload};
        case SET_TRIP_ID:
            return {...state, tripId: action.payload};
        case SET_NOTES:
            return {...state, notes: action.payload};
        case SET_DEALER_CLIENT:
            return {...state, client: action.payload};
        case SET_REFUNDABLE:
            return {...state, refundable: action.payload};
		case SET_GUEST_INFO:
            return {...state, guestInfo: action.payload};
        default:
            return state;
    }
};